module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iSG9tZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMjEuMzIgMjEuMzgiPjxkZWZzPjxzdHlsZT4uY2xzLTF7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+RElNRVItV0VCLTIwMjAwMjI0LeiLseaWh+eVjOmdojwvdGl0bGU+PHJlY3QgY2xhc3M9ImNscy0xIiB3aWR0aD0iMjEuMzIiIGhlaWdodD0iNC4wMyIvPjxyZWN0IGNsYXNzPSJjbHMtMSIgeT0iOC42NyIgd2lkdGg9IjIxLjMyIiBoZWlnaHQ9IjQuMDMiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHk9IjE3LjM1IiB3aWR0aD0iMjEuMzIiIGhlaWdodD0iNC4wMyIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/bread.svg
// module id = eKjA
// module chunks = 0